import React from 'react'

class Footer extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="content">
          <center>
            <b>
              <div className="columns">
                <div className="column">
                  &copy; 2018 BurzNest LLC
                </div>
                <div className="column">
                  <div className="field">
                    <a href="mailto:contact@burznest.com">Contact BurzNest</a>
                  </div>
                </div>
              </div>
            </b>
          </center>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/Footer.js